module.exports = __webpack_public_path__ + "VE.png?ea7c6d4e1acc7d3812cd0b3c49d913ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/VE.png
// module id = 416
// module chunks = 0